




































































import Vue from "vue";
import { App } from "@/types/app";
import storeHelper from "../store/store-helper";
import Shared from "../shared";
import QrcodeVue from "qrcode.vue";
import Utils from "@/utils";
import Toolbar from "../components/toolbar/Toolbar.vue";

export default Vue.extend({
    name: "Apps",
    components: { QrcodeVue, Toolbar },
    props: {},
    data: () => {
        return {
            apps: [] as App[],
            userLanguage: {} as String,
            qrCode: ""
        };
    },
    async created() {
        const user = storeHelper.userStore.loggedOnUser;
        this.userLanguage = user.language.substring(0, 2).toUpperCase();
        await storeHelper.appsStore.loadApps();
        this.apps = storeHelper.appsStore.apps;
        this.qrCode = btoa(Shared.iProvaUrl.toLowerCase() + "/" + "||" + user.login_code);
        document.title = Utils.getPageTitle(`${this.$t("general.toolbar.apps")}`, "before");
    },
    methods: {
        onClickFunction(url) {
            window.open(url);
        }
    }
});
